import { Box } from '@mui/material';
import parse from 'html-react-parser';
import React, { useState } from 'react';
import sanitizeHtml from 'sanitize-html';
import Select from '../../../../components/select/Select';
import { PspsEvent } from '../../../../types';

export default function PspsEventList({ pspsEvents }: { pspsEvents?: PspsEvent[] }): JSX.Element {
  const [languageKey, setLanguageKey] = useState<string>();

  if (!pspsEvents?.length) {
    return <></>;
  }

  // Get a dictionary of all possible languages and their display values
  const languages = pspsEvents.reduce((dictionary: Record<string, string>, pspsEvent) => {
    Object.keys(pspsEvent.content).forEach((key) => {
      dictionary[key] = pspsEvent.content[key].name;
    });
    return dictionary;
  }, {});

  const currentLanguageKey = languageKey || 'en';
  const eventsInCurrentLanguage = pspsEvents?.filter(
    (pspsEvent) => pspsEvent.content[currentLanguageKey],
  );

  return (
    <Box mb={2}>
      {eventsInCurrentLanguage.map(({ id, content }) => (
        <React.Fragment key={id}>
          <div>{renderSanitizedHtml(content[currentLanguageKey].header)}</div>
          <div>{renderSanitizedHtml(content[currentLanguageKey].htmlDescription)}</div>
        </React.Fragment>
      ))}
      <Box>
        <Select
          action="maps-psps-events-language"
          label="Language"
          value={currentLanguageKey}
          onChange={(value) => setLanguageKey(value)}
          options={Object.keys(languages).map((languageKey) => ({
            value: languageKey,
            label: languages[languageKey],
          }))}
        />
      </Box>
    </Box>
  );
}

const SANITIZE_OPTIONS: sanitizeHtml.IOptions = {
  allowedTags: [...sanitizeHtml.defaults.allowedTags, 'h1', 'h2', 'h3', 'img'],
  allowedAttributes: {
    ...sanitizeHtml.defaults.allowedAttributes,
    a: ['href', 'title'],
    img: ['src', 'alt'],
  },
  allowedSchemes: ['http', 'https', 'mailto', 'tel'],
  enforceHtmlBoundary: true,
};

function renderSanitizedHtml(html?: string) {
  return parse(sanitizeHtml(html ?? '', SANITIZE_OPTIONS));
}
